import { triangle } from 'polished';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import OpenArrow from './open-indicator';

const HoverMenuStyle = styled.li`
  display: inline-block;
  position: relative;
  padding: 0;
`;

const HoverMenuWrapper = styled.div<{ isOpen: boolean }>`
  padding-top: 5px;
  position: absolute;
  left: -75px;
  z-index: 10;
  display: ${props => (props.isOpen ? `block` : `none`)};
`;

export const HoverMenuContainer = styled.div<{
  pointOffset?: number | string;
  isShiftLeft?: boolean;
}>`
  padding: 0;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  transform-style: flat;
  &::before,
  &::after {
    left: 80px;
  }
  &:before {
    content: '';
    ${props => (props.pointOffset ? `left: ${props.pointOffset}` : '')};
    position: absolute;
    top: -4px;
    ${triangle({
      pointingDirection: 'top',
      width: '18px',
      height: '9px',
      foregroundColor: '#ddd',
    })};
  }
  &:after {
    content: '';
    ${props => (props.pointOffset ? `left: ${props.pointOffset}` : '')};
    position: absolute;
    top: -3px;
    ${triangle({
      pointingDirection: 'top',
      width: '18px',
      height: '9px',
      foregroundColor: 'white',
    })};
  }
  ${props =>
    props.isShiftLeft &&
    css`
      margin-left: -40px;
    `}
`;

type Props = {
  menuItem: React.ReactElement;
  pointOffset?: string | number;
  hasFancyArrow?: boolean;
  isShiftLeft?: boolean;
};

const HoverMenu: React.FC<Props> = ({
  menuItem,
  children,
  pointOffset,
  hasFancyArrow,
  isShiftLeft,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  return (
    <HoverMenuStyle
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      {...props}
    >
      {menuItem}
      {hasFancyArrow && <OpenArrow open={open} />}
      <HoverMenuWrapper isOpen={open}>
        <HoverMenuContainer pointOffset={pointOffset} isShiftLeft={isShiftLeft}>
          {children}
        </HoverMenuContainer>
      </HoverMenuWrapper>
    </HoverMenuStyle>
  );
};

export default HoverMenu;
